import { Anchor, Text, rem } from '@mantine/core';
import { createElement, ReactNode, ElementType } from 'react';

type Size = 'sm' | 'md';
type IconComp = ElementType<{ size?: number; color?: string }>;

export interface AfaAnchorProps {
  href?: string;
  leftIcon?: IconComp;
  rightIcon?: IconComp;
  children: ReactNode;
  size?: Size;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  target?: string;
  rel?: string;
}

export function AfaAnchor({
  href = '#',
  leftIcon,
  rightIcon,
  children,
  size = 'sm',
  style,
  onClick,
  className,
  target,
  rel,
}: AfaAnchorProps) {
  const iconPx = size === 'md' ? 16 : 14;
  const colorVar = 'var(--mantine-color-brand-5)';

  const L = leftIcon ? createElement(leftIcon, { size: iconPx, color: colorVar }) : null;
  const R = rightIcon ? createElement(rightIcon, { size: iconPx, color: colorVar }) : null;

  return (
    <Anchor
      href={href}
      underline="hover"
      onClick={onClick}
      className={className ?? ''}
      {...(target && { target })}
      {...(rel && { rel })}
      style={{
        color: colorVar,
        fontSize: size === 'md' ? '1rem' : '0.875rem',
        display: 'inline-flex',
        alignItems: 'center',
        gap: rem(6),
        textDecorationThickness: rem(1),
        ...style,
      }}
      onMouseOver={e => {
        (e.currentTarget as HTMLAnchorElement).style.textDecorationColor = colorVar;
      }}
      onMouseOut={e => {
        (e.currentTarget as HTMLAnchorElement).style.textDecorationColor = '';
      }}
    >
      {L}
      <Text
        component="span"
        size={size}
        c={colorVar}
        fw={400}
        lh={1}
      >
        {children}
      </Text>
      {R}
    </Anchor>
  );
}

export default AfaAnchor;
